<template>
	<component :is="themeCfg"
	    :query-cfg="queryCfg"></component>
</template>
<script>
export default {
	name: "OrderScreen",

	data() {
		return {
			themeCfg: '',
			queryCfg: '1,2,3,5,6', 
		}
	},

	created() {
		import(`./customise/os-default`)
			.then(themeCfg => {
				if (themeCfg) {
					this.themeCfg = themeCfg.default
				}
			})
	},
}
</script>
<style lang="less">
@import './components/os-chart.less';
	
</style>